<script>

import Service from '../../../services/equipment-operation';
import FiscalNotificationService from '../../../services/fiscal-notification';

import Card from 'primevue/card';
import Calendar from 'primevue/calendar';
import InputNumber from 'primevue/inputnumber';
import Button from 'primevue/button';
import CommonConstants from '../../../common/Constants';
import Utils from '../../../common/Utils';
import GenericCustomMasterDataAutocompleteV2 from '../../generic/GenericCustomMasterDataAutocompleteV2.vue'
//import GenericCustomAutocompleteV2 from '../../generic/GenericCustomAutocompleteV2.vue'
import EquipmentOperationService from '../../../services/equipment-operation';

export default{
    props: ['executeCalculation'],
    components: {
        Card, Calendar, InputNumber, Button,
        GenericCustomMasterDataAutocompleteV2 //, GenericCustomAutocompleteV2
    },
    data(){
        return {
            tankSelected: null,
            isGas: false,
            data: {
                tankCode: null,
                calculationDate: null,
                inService: true,
                productId: null,
                density15: null,
                measureType: 'Full',
                productLevel: null,
                feetPosition: 'D',
                calibrationTemperature: null,
                previousOperationDensity15: null,
                previousOperationVolume15: null,
                previousOperationWeight: null,
                sampleBarrelData: {
                    density15SampleBarrel: null,
                    waterVolumePercentage: null,
                    sedimentsVolumePercentage: null,
                    waterAndSedimentsVolumePercentage: null
                }
            },
            movementData: {
                movementType: 'I'
            },
            footPositionOptions: [
                {
                    value: 'D',
                },
                {
                    value: 'H'
                }
            ],
            movementTypes: [
                {
                    value: 'I'
                },
                {
                    value: 'O'
                },
            ],
            idScheduledOperation: null,
            isPartialMeasure: false,
            limsDataDialogVisible: false,
            dischargeTanks: ['S BAR','N BAR'],
            limsData: {
                params: {
                    pageType: 'Discarica',
                    sampleNumber: null,
                    samplingPoint: null,
                    measureDate: null 
                }
            },
            dialog: {
                params: {
                    samplingNumber: null
                },
                data: {

                }
            },
            samplingNumbers: [],
            limsDetailsDialogVisible: false
        }
    },
    validations(){
        return {
            data: {
                tankCode: {required},
                calculationDate: {required},
                productId: {required},
                gasPressure: {customValidation: value => !this.isGas || value},
                gasTemperature: {customValidation: value => !this.isGas || value},
                molecularWeight: {customValidation: value => !this.isGas || value},
                productLevel: {required},
                environmentTemperature: {required},
                temperature: {required},
                density15: {required},
                waterLevel: {required},
            },
        }
    },
    methods: {
        onTankSelected(event){
            if(event){
                this.tankSelected = event.value;
                if(event.extraData){
                    this.data.calibrationTemperature = event.extraData.calibrationTemperature;
                    this.data.feetPosition = event.extraData.feetPosition;
                }
            }
        },
        onProductSelected({extraData}){
            this.isGas = extraData.isGas;
        },
        onFeetPositionSelect(event){
            if(this.tankSelected != null){
                if(event.value != this.tankSelected.feetPosition && (this.tankSelected.feetPosition == 'D' || this.tankSelected.feetPosition == 'H')){
                    this.$confirm.require({
                        message: this.$t('calculatorInsertData.wrongFeetMessage', {tankCode: this.tankSelected.code, feetPosition: this.$t('calculatorTankDevelopment.footPosition' + this.tankSelected.feetPosition)}),
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: this.$t('yes'),
                        rejectLabel: this.$t('no'),
                        accept: () => {
                            
                        },
                        reject: () => {
                            this.data.feetPosition = this.tankSelected.feetPosition;
                            //callback to execute when user rejects the action
                            this.$confirm.close();
                        }
                    });
                }
            }
        },
        loadLastOperation(){

            if(this.data.tankCode && this.data.calculationDate){
                let body = {
                    tankCode: this.data.tankCode,
                    date: this.data.calculationDate
                }
                
                this.data.previousOperationDensity15 = null;
                this.data.previousOperationVolume15 = null;
                this.data.previousOperationWeight = null;
                EquipmentOperationService.getLastOperation(body, response => {
                    if(response.success){
                        let lastOperation = response.data;
                        if(lastOperation){
                            this.data.previousOperationDensity15 = lastOperation.density15;
                            this.data.previousOperationVolume15 = lastOperation.stockVolume15;
                            this.data.previousOperationWeight = lastOperation.stockWeight;
                        }
                    }
                })
            }
        },
        populateInput(data){
            let input = {
                tankCode: data.tankCode,
                calculationDate: data.operationDate,
                productId: data.idRegistryProduct,
                density15: data.density15,
                measureType: 'Full',
                productLevel: data.productLevel,
                environmentTemperature: data.environmentTemperature,
                temperature: data.temperature,
                feetPosition: this.data.feetPosition,
                waterLevel: data.waterLevel,
                calibrationTemperature: null,
                sampleBarrelData: {
                    density15SampleBarrel: null,
                    waterVolumePercentage: null,
                    sedimentsVolumePercentage: null,
                    waterAndSedimentsVolumePercentage: null
                }
            }
            this.idScheduledOperation = data.idOperativePlan;
            this.isPartialMeasure = data.isPartialMeasure;
            this.data = input;

            if(this.idScheduledOperation && this.isPartialMeasure){
                this.getAutocompletePartialMeasureValues();
            }
            //this.$refs.tankAC.callOnItemSelect();
        },
        getInputData(){
            return this.data; 
        },
        importFromPI(){
            this.$store.dispatch("generic/setLoading", true);
            Service.importFromPI({date: this.data.calculationDate, tank: this.data.tankCode}, ({success, data}) =>{
                this.$store.dispatch("generic/setLoading", false);
                if(success){
                data.reverse().forEach(({items}) => {
                    const [{description, value}] = items;
                    const key = {
                    'EnvironmentTemperature': 'environmentTemperature',
                    'Level': 'productLevel',
                    'Temperature': 'temperature',
                    'Density': 'density15',
                    'Pressure': 'gasPressure',
                    'Gas Temperature': 'gasTemperature'
                    }?.[description];

                    key && (this.data[key] = value);
                })
                } else {
                    this.$toast.add({detail: this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        getAutocompletePartialMeasureValues(){
            if(this.isPartialMeasure && this.idScheduledOperation){
                let body = {
                    tankCode: this.data.tankCode,
                    idScheduledOperation: this.idScheduledOperation
                }
                FiscalNotificationService.getAutocompletePartialMeasureValues(body, (response) => {
                    if(response.success){
                        if(response.data.productLevel){
                            this.data.productLevel = response.data.productLevel;
                        }
                        if(response.data.temperature){
                            this.data.temperature = response.data.temperature;
                        }
                        if(response.data.operationDate){
                            this.data.calculationDate = new Date(Utils.dateToCurrentTimeZone(response.data.operationDate));
                        }
                    }
                })
            }
        },
        getAutocompleteTankCalculationValues(){
            if(!this.isPartialMeasure && this.data.tankCode && this.data.calculationDate && this.data.productId && this.idScheduledOperation){
                let body = {
                    tankCode: this.data.tankCode,
                    idScheduledOperation: this.idScheduledOperation,
                    operationDate: Utils.formatDateForAPIWithTime(this.data.calculationDate),
                    idProduct: this.data.productId
                }
                Service.getAutocompleteTankCalculationValues(body, (response) => {
                    if(response.success){
                        if(response.data.density15){
                            this.data.density15 = response.data.density15;
                        }
                        if(response.data.environmentTemperature){
                            this.data.environmentTemperature = response.data.environmentTemperature;
                        }
                        if(response.data.molecularWeight){
                            this.data.molecularWeight = response.data.molecularWeight;
                        }
                        if(response.data.waterLevel){
                            this.data.waterLevel = response.data.waterLevel;
                        }
                    }
                })
            }
        },
        loadLimsData(){
            this.limsDataDialogVisible = true;
        },
        loadLimsDetailsData(){
            let params = {
                pageType: this.limsData.params.pageType,
                sampleNumber: this.limsData.params.sampleNumber,
                samplingPoint: this.limsData.params.samplingPoint,
                measureDate: this.limsData.params.measureDate ? Utils.formatDateForAPI(this.limsData.params.measureDate) : null
            }
            this.dialog.data = {};
            this.samplingNumbers = [];
            this.dialog.params.samplingNumber = null;
            this.$store.dispatch("generic/setLoading", true);

            Service.getLimsAdvancedSearch(
                params, 
                ({success, message, data}) => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(success){
                        if(data.moreThanOneSampleFound){
                            this.limsDetailsDialogVisible = true;
                            Service.getLimsAdvancedSearchCompleteList(
                                params,
                                ({success, message, data}) => {
                                    if(success){
                                        this.samplingNumbers = [...data]
                                    }else{
                                        this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                    }
                                }
                            )

                        }else{
                            this.dialog.data = {...data.measures}
                            this.dialog.data.dataPrelievo = Utils.formatDateTime(new Date(this.dialog.data.dataPrelievo))
                        }
                    }else{
                        this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }
            )
        },
        selectSamplingNumber(){
            this.limsDetailsDialogVisible = false;
            this.limsData.params.sampleNumber = this.dialog.params.samplingNumber.value;
            this.loadLimsDetailsData();
        },
        convertLimsData(){
            let params = {
                barrelDensity: this.dialog.data.densita15,
                waterWeightContent: this.dialog.data.percentualePesoAcqua,
                sedimentsWeightContent: this.dialog.data.percentualePesoSedimenti
            }
            Service.convertWaterAndSediments(params, 
                (response) => {
                    if(response.success){
                        this.dialog.data.percentualeVolumeAcqua = response.data.percentualeVolumeAcqua;
                        this.dialog.data.percentualeVolumeSedimenti = response.data.percentualeVolumeSedimenti
                        this.dialog.data.percentualeVolumeAcquaSedimenti = response.data.percentualeVolumeAcquaSedimenti
                    }
                }
            )
        },
        importFromLims(){
            this.data.sampleBarrelData.density15SampleBarrel = this.dialog.data.densita15;
            this.data.sampleBarrelData.waterVolumePercentage = this.dialog.data.percentualeVolumeAcqua;
            this.data.sampleBarrelData.sedimentsVolumePercentage = this.dialog.data.percentualeVolumeSedimenti;
            this.data.sampleBarrelData.waterAndSedimentsVolumePercentage = this.dialog.data.percentualeVolumeAcquaSedimenti;

            this.limsDataDialogVisible = false;
        },
        loadEnvironmentTemperature(){
            if(this.data.calculationDate){
                Service.getEnvironmentTemperature({date: this.data.calculationDate}, (response) => {
                    if(response.success){
                        this.data.environmentTemperature = response.data;
                    }else{
                        this.data.environmentTemperature = null;
                    }
                })
            }
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
        selectedPageType(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData ? this.dialog.params.samplingNumber.extraData.pageType : null
        },
        selectedSamplingPoint(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData ? this.dialog.params.samplingNumber.extraData.samplingPoint : null
        },
        selectedProduct(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData ? this.dialog.params.samplingNumber.extraData.product : null
        },
        selectedSamplingDate(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData && this.dialog.params.samplingNumber.extraData.samplingDate ? Utils.formatDateTime(new Date(this.dialog.params.samplingNumber.extraData.samplingDate)) : null
        },
        selectedVoyageNumber(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData ? this.dialog.params.samplingNumber.extraData.voyageNumber : null
        },
        selectedVessel(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData ? this.dialog.params.samplingNumber.extraData.vessel : null
        },
        selectedAnalysisList(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData ? this.dialog.params.samplingNumber.extraData.analysisList : []
        },
        // percentualeVolumeAcquaSedimenti(){
        //     let percVolAcqua = this.dialog && this.dialog.data && this.dialog.data.percentualeVolumeAcqua ? this.dialog.data.percentualeVolumeAcqua : 0;
        //     let percVolSedimenti = this.dialog && this.dialog.data && this.dialog.data.percentualeVolumeSedimenti ? this.dialog.data.percentualeVolumeSedimenti : 0;
        //     return percVolAcqua + percVolSedimenti;
        // }
    }, 
    watch: {
        'data.tankCode'() {
            this.loadLastOperation();
            this.getAutocompleteTankCalculationValues();
        },
        'data.calculationDate'() {
            if(this.data.calculationDate){
                Utils.nullSAndMS(this.data.calculationDate)
            }
            this.loadEnvironmentTemperature();
            this.loadLastOperation();
            this.getAutocompleteTankCalculationValues();
        },
        'data.productId'(){
            this.getAutocompleteTankCalculationValues();
        }
    }
}
</script>

<template>

    <Dialog v-model:visible="limsDataDialogVisible" modal closable :style="{width: '85vw'}" >
        <div class="grid" >
            <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.tank')}}</label>
                <Dropdown class="w-full p-inputtext-sm" :placeholder="null" v-model="limsData.params.samplingPoint" :options="dischargeTanks" />
            </div>
            <div class="col-12 lg:col-6 field">
                <label>{{$t('calculatorInsertData.date_hour')}}</label>
                <Calendar 
                    v-model="limsData.params.measureDate"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false" :hideOnDateTimeSelect="true"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                    class="w-full p-inputtext-sm " />
            </div>
             <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.sampleNumber')}}</label>
                <InputText type="text" v-model="limsData.params.sampleNumber" :class="{'w-full p-inputtext-sm': true}" />
            </div>
             <div class="col-12 lg:col-6 field mt-5">
                <Button :label="$t('calculatorTankDevelopment.btnLimsLoad')" icon="pi pi-upload" class="m-2 p-button-sm" @click="loadLimsDetailsData" :disabled="!uiPermissions('tankCalculatorLimsButton').isEnabled" />
            </div>
        </div>
        <div class="grid formgrid" >
            <div class="col-12">
            <Card>
                <template #content>
                    <div class="grid formgrid" >
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.type')}}</label>
                            <InputText type="text" readonly v-model="dialog.data.tipologia" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.puntoPrelievo')}}</label>
                            <InputText type="text" readonly v-model="dialog.data.puntoPrelievo" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.prodotto')}}</label>
                            <InputText type="text" readonly v-model="dialog.data.prodotto" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.dataPrelievo')}}</label>
                            <InputText type="text" readonly v-model="dialog.data.dataPrelievo" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.viaggio')}}</label>
                            <InputText type="text" readonly v-model="dialog.data.viaggio" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.nave')}}</label>
                            <InputText type="text" readonly v-model="dialog.data.nave" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.densita15')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputText :minFractionDigits="4" :maxFractionDigits="4" type="text" readonly v-model="dialog.data.densita15Valore" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">{{dialog.data.densita15UnitaMisura}}</span>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.contenutoAcqua')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputText :minFractionDigits="3" :maxFractionDigits="3" type="text" readonly v-model="dialog.data.contenutoAcquaValore" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">{{dialog.data.contenutoAcquaUnitaMisura}}</span>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.sedimentiPerEstrazione')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputText :minFractionDigits="3" :maxFractionDigits="3" type="text" readonly v-model="dialog.data.sedimentiPerEstrazioneValore" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">{{dialog.data.sedimentiPerEstrazioneUnitaMisura}}</span>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.contenutoAcquaSedimenti')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputText :minFractionDigits="3" :maxFractionDigits="3" type="text" readonly v-model="dialog.data.contenutoAcquaSedimentiValore" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">{{dialog.data.contenutoAcquaSedimentiUnitaMisura}}</span>
                            </div>
                        </div>
                       
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.densita15')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputNumber :minFractionDigits="4" :maxFractionDigits="4" type="text"  v-model="dialog.data.densita15" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">Kg/Lt</span>
                            </div>
                        </div>
                    </div>
                    <div class="grid formgrid" >
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.contenutoAcqua')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputNumber :minFractionDigits="3" :maxFractionDigits="3" type="text"  v-model="dialog.data.percentualePesoAcqua" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">% wt</span>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>% vol</label>
                            <div class="p-inputgroup w-full">
                                <InputNumber :minFractionDigits="3" :maxFractionDigits="3" type="text"  v-model="dialog.data.percentualeVolumeAcqua" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">% vol</span>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.sedimentiPerEstrazione')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputNumber :minFractionDigits="3" :maxFractionDigits="3" type="text"  v-model="dialog.data.percentualePesoSedimenti" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">% wt</span>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6 field">                            
                            <label>% vol</label>
                            <div class="p-inputgroup w-full">
                                <InputNumber :minFractionDigits="3" :maxFractionDigits="3" type="text"  v-model="dialog.data.percentualeVolumeSedimenti" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">% vol</span>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.contenutoAcquaSedimenti')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputNumber :minFractionDigits="3" :maxFractionDigits="3" type="text"  v-model="dialog.data.percentualeVolumeAcquaSedimenti" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">% vol</span>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6 field mt-5">
                            <Button :label="$t('btn.convert')" icon="pi pi-import" @click="convertLimsData" />
                        </div>
                    </div>
                </template>
            </Card>
        </div>
        </div>
        <template #footer>
            <Button :label="$t('btn.import')" icon="pi pi-import" @click="importFromLims" />
        </template>
    </Dialog>
    <Dialog v-model:visible="limsDetailsDialogVisible" modal closable :style="{width: '85vw'}" >
        <div class="grid" >
            <div class="col-12 field">
                <label>{{$t('limsInterface.sampleNumber')}}</label>
                <Dropdown class="w-full p-inputtext-sm" :placeholder="null" v-model="dialog.params.samplingNumber" :options="samplingNumbers" optionLabel="label" />
            </div>
        </div>
        <div class="grid" >
            <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.type')}}</label>
                <InputText type="text" readonly v-model="selectedPageType" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.puntoPrelievo')}}</label>
                <InputText type="text" readonly v-model="selectedSamplingPoint" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.prodotto')}}</label>
                <InputText type="text" readonly v-model="selectedProduct" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.dataPrelievo')}}</label>
                <InputText type="text" readonly v-model="selectedSamplingDate" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.viaggio')}}</label>
                <InputText type="text" readonly v-model="selectedVoyageNumber" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.nave')}}</label>
                <InputText type="text" readonly v-model="selectedVessel" :class="{'w-full p-inputtext-sm': true}" />
            </div>
        </div>
        <div class="grid">
            <div class="col-12">
                <DataTable :value="selectedAnalysisList" tableStyle="width: 100%" scrollable scrollHeight="400px">
                    <Column field="analysisCode" :header="$t('limsInterface.analysisCode')" />
                    <Column field="analysisDescription" :header="$t('limsInterface.analysisDescription')" />
                    <Column field="analysisMethod" :header="$t('limsInterface.analysisMethod')" />
                    <Column field="measureUnit" :header="$t('limsInterface.measureUnit')" />
                    <Column field="analysisValue" :header="$t('limsInterface.analysisValue')" />
                </DataTable>
            </div>
        </div>
        <template #footer>
            <Button :label="$t('btn.import')" icon="pi pi-import" @click="selectSamplingNumber" />
        </template>
    </Dialog>
    <Card>
        <template #subtitle>
            {{$t('calculatorTankDevelopment.title')}}
        </template>
        <template #content>
            <div class="grid formgrid" >
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorInsertData.container')}}</label>
                    <div>          
                        <GenericCustomMasterDataAutocompleteV2
                            ref="tankAC"
                            :changeFn="onTankSelected"
                            class="w-full p-inputtext-sm"
                            v-model="data.tankCode"
                            name="tank-management-tank-combo"
                            :format="{ label: 'code', value: 'code' }"
                            api="tank-management/tank-combo" />   
                    </div> 
                </div>  
                <!-- <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorInsertData.inService')}}</label>
                    <GenericBooleanDropdown
                      id="inService" 
                      v-model="data.inService" 
                      class="w-full p-inputtext-sm " />
                </div> -->
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorInsertData.date_hour')}}</label>
                    <Calendar 
                        v-model="data.calculationDate"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="true" :hideOnDateTimeSelect="true"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                        class="w-full p-inputtext-sm " />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorInsertData.product')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        :changeFn="onProductSelected"
                        v-model="data.productId"
                        name="products" 
                        api="masterdata/product-combo"
                        class="p-inputtext-sm"/>
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.level')}}</label>
                    <InputNumber class="p-inputtext-sm w-full" id="level"  v-model="data.productLevel" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.levWater')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" v-model="data.waterLevel" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.tempAmb')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" v-model="data.environmentTemperature" 
                        :minFractionDigits="2" :maxFractionDigits="2"/>
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.tempCalib')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="data.calibrationTemperature" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.tempLiq')}}</label>
                    <InputNumber class="w-full p-inputtext-sm"  v-model="data.temperature" 
                        :minFractionDigits="2" :maxFractionDigits="2"/>
                </div>
                <template v-if="isGas">
                    <div class="col-12 lg:col-6 field">
                        <label>{{$t('calculatorTankDevelopment.gasPressure')}}</label>
                        <InputNumber class="w-full p-inputtext-sm"  v-model="data.gasPressure" 
                            :minFractionDigits="2" :maxFractionDigits="2"/>
                    </div>
                    <div class="col-12 lg:col-6 field">
                        <label>{{$t('calculatorTankDevelopment.gasTemperature')}}</label>
                        <InputNumber class="w-full p-inputtext-sm"  v-model="data.gasTemperature" 
                            :minFractionDigits="2" :maxFractionDigits="2"/>
                    </div>
                    <div class="col-12 lg:col-6 field">
                        <label>{{$t('calculatorTankDevelopment.molecularWeight')}}</label>
                        <InputNumber class="w-full p-inputtext-sm"  v-model="data.molecularWeight" 
                            :minFractionDigits="2" :maxFractionDigits="2"/>
                    </div>
                </template>
                
                <div class="col-12 p-card-subtitle my-4">{{$t('calculatorDischargeDevelopment.prevOperationTitle')}}</div>

                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.vol15')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" v-model="data.previousOperationVolume15" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.pesoGiacenza')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" v-model="data.previousOperationWeight" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.density')}}</label>
                    <InputNumber mode="decimal" :minFractionDigits="4" :maxFractionDigits="4" class="w-full p-inputtext-sm" v-model="data.previousOperationDensity15" />
                </div>

                <div class="col-12 p-card-subtitle my-4">{{$t('calculatorDischargeDevelopment.sampleTitle')}}</div>
                
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorDischargeDevelopment.density')}}</label>
                    <InputNumber mode="decimal" :minFractionDigits="4" :maxFractionDigits="4" class="w-full p-inputtext-sm" v-model="data.sampleBarrelData.density15SampleBarrel" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorDischargeDevelopment.contAcqua')}}</label>
                    <InputNumber mode="decimal" :minFractionDigits="3" :maxFractionDigits="3" class="w-full p-inputtext-sm" v-model="data.sampleBarrelData.waterVolumePercentage" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorDischargeDevelopment.sediments')}}</label>
                    <InputNumber mode="decimal" :minFractionDigits="3" :maxFractionDigits="3" class="w-full p-inputtext-sm" v-model="data.sampleBarrelData.sedimentsVolumePercentage" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorDischargeDevelopment.contAcquaSediments')}}</label>
                    <InputNumber mode="decimal" :minFractionDigits="3" :maxFractionDigits="3" class="w-full p-inputtext-sm" v-model="data.sampleBarrelData.waterAndSedimentsVolumePercentage" />
                </div>
            </div>
        </template>
        <template #footer>
            <Button :label="$t('calculatorDischargeDevelopment.calculate')" icon="pi pi-cog" class="m-2 p-button-sm" @click="executeCalculation(data)" :disabled="!uiPermissions('tankCalculatorButton').isEnabled"/>
            <Button :label="$t('cvtDeviation.btn.importFromPI')" icon="pi pi-upload" class="m-2 p-button-sm" @click="importFromPI" :disabled="!uiPermissions('tankCalculatorPIButton').isEnabled" />
            <Button :label="$t('calculatorDischargeDevelopment.limsData')" icon="pi pi-cog" class="m-2 p-button-sm" @click="loadLimsData" :disabled="!uiPermissions('tankCalculatorButton').isEnabled"/>
        </template>
    </Card>
</template>